import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './GeneralInfoForm.css';

const PositionForm = ({ positionId, initialData, onSuccess }) => {
     const baseUrl = process.env.REACT_APP_BASE_URL;

     const [loading, setLoading] = useState(false);
     const [error, setError] = useState('');
     const navigate = useNavigate();

     const [positionName, setPositionName] = useState(initialData?.position_type || '');

     useEffect(() => {
          setPositionName(initialData?.position_type || '');
     }, [initialData]);

     const handleSubmit = async (e) => {
          e.preventDefault();

          if (!positionName.trim()) {
               setError('Position name is required');
               return;
          }

          setLoading(true);
          setError('');

          try {
               let url = '';
               let method = 'POST';
               let body = {};

               if (positionId) {
                    // ✅ Edit mode
                    url = `${baseUrl}/updateUserPositById/${positionId}`;
                    body = { position: positionName };
               } else {
                    // ✅ Create mode
                    url = `${baseUrl}/createUserPosit`;
                    body = { position: positionName };
               }

               const response = await fetch(url, {
                    method,
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(body),
               });

               const data = await response.json();

               if (data.status) {
                    alert(positionId ? 'Position updated successfully' : 'Position created successfully');
                    if (onSuccess) onSuccess();
                    navigate('/position');
               } else {
                    setError(data.message || `Failed to ${positionId ? 'update' : 'create'} PYAGROUP`);
               }
          } catch (err) {
               setError('Error connecting to server');
          } finally {
               setLoading(false);
          }
     };

     return (
          <form className="general-info-form" onSubmit={handleSubmit}>
               {/* <h2 className="section-title">{positionId ? 'Edit Position' : 'Add Position'}</h2> */}
               <div className="form-grid">
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control"
                              id="positionName"
                              placeholder=" "
                              autoComplete="off"
                              value={positionName}
                              onChange={(e) => setPositionName(e.target.value)}
                              disabled={loading}
                         />
                         <label htmlFor="positionName">Position Name</label>
                    </div>
               </div>
               {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}
               <button
                    type="submit"
                    className="btn btn-primary"
                    style={{ marginTop: '15px' }}
                    disabled={loading}
               >
                    {loading ? 'Saving...' : 'Save'}
               </button>
          </form>
     );
};

export default PositionForm;
